import currency from './currency'
import declension from './declension'

export default {
    install(Vue) {
        Vue.filter('currency', currency)
        Vue.filter('declension', declension)
    },
}
